import * as tslib_1 from "tslib";
import { IgrDefinitionBase } from "./igr-definition-base";
import { HeaderSeparator } from "./HeaderSeparator";
var IgrHeaderSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrHeaderSeparator, _super);
    function IgrHeaderSeparator(props) {
        return _super.call(this, props) || this;
    }
    IgrHeaderSeparator.prototype.createImplementation = function () {
        return new HeaderSeparator();
    };
    Object.defineProperty(IgrHeaderSeparator.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    return IgrHeaderSeparator;
}(IgrDefinitionBase));
export { IgrHeaderSeparator };
//# sourceMappingURL=igr-header-separator.js.map
